module.exports = __webpack_public_path__ + "assets/images/1a55247672a356cc974cef6ac4d2df52.png";